import Cookies from 'js-cookie';
import { COOKIES } from '@avanta/shared/constants/storage';

export const COOKIE_DURATION_MINUTES = 30;

export const clearRecoveryCookies = (): void => {
  Cookies.remove(COOKIES.RECOVERY_EMAIL);
  Cookies.remove(COOKIES.VERIFICATION_CODE);
};

export const saveRecoveryCookies = (email: string, code?: string): void => {
  Cookies.set(COOKIES.RECOVERY_EMAIL, email, { expires: COOKIE_DURATION_MINUTES / (24 * 60) });
  if (code) {
    Cookies.set(COOKIES.VERIFICATION_CODE, code, { expires: COOKIE_DURATION_MINUTES / (24 * 60) });
  }
};

export const getStoredRecoverySession = (): { email?: string; code?: string } => ({
  email: Cookies.get(COOKIES.RECOVERY_EMAIL),
  code: Cookies.get(COOKIES.VERIFICATION_CODE),
});

export const validatePasswordMatch = (password: string, confirmPassword: string): void => {
  if (password !== confirmPassword) {
    throw new Error('RecoverPassword.passwordsDoNotMatch');
  }
};

export const validateVerificationCode = (code: string): void => {
  if (!code) {
    throw new Error('RecoverPassword.verificationCodeRequired');
  }
};

export const validateCodeLength = (code: string, expectedLength: number): boolean =>
  code.length === expectedLength;
